import { toast } from 'react-toastify';
import { axiosInstance } from '../../repository/Repository';
import {
    GET_STAFF_START,
    GET_STAFF_SUCCESS,
    GET_STAFF_ERROR,
    ADD_STAFF_START,
    ADD_STAFF_SUCCESS,
    ADD_STAFF_ERROR,
    UPDATE_STAFF_START,
    UPDATE_STAFF_SUCCESS,
    UPDATE_STAFF_ERROR,
    DELETE_STAFF_START,
    DELETE_STAFF_SUCCESS,
    DELETE_STAFF_ERROR,
} from './staffTypes';

// Get all staff members for current business (admin)
export const getStaff = (page = 1, limit = 10) => async (dispatch) => {
    dispatch({ type: GET_STAFF_START });
    try {
        const response = await axiosInstance.get('/business-staff/my', {
            params: { page, limit }
        });
        console.log('Staff Response:', response.data); // Debug log
        
        let staffData = [];
        let total = 0;
        let currentPage = page;
        let currentLimit = limit;
        
        if (response.data.data) {
            // Handle new paginated array structure: [ { data: [], total, page, limit } ]
            if (Array.isArray(response.data.data) && response.data.data[0] && typeof response.data.data[0] === 'object' && 'data' in response.data.data[0]) {
                const paginatedObj = response.data.data[0];
                staffData = paginatedObj.data || [];
                total = paginatedObj.total || 0;
                currentPage = paginatedObj.page || page;
                currentLimit = paginatedObj.limit || limit;
            } else if (Array.isArray(response.data.data) && Array.isArray(response.data.data[0])) {
                staffData = response.data.data[0];
                total = staffData.length;
            } else if (Array.isArray(response.data.data)) {
                staffData = response.data.data;
                total = staffData.length;
            } else {
                staffData = response.data.data;
                total = staffData?.total || 0;
            }
        } else {
            staffData = response.data || [];
            total = staffData.length;
        }
        
        console.log('Processed Staff Data:', staffData, 'Total:', total); // Debug log
        dispatch({ 
            type: GET_STAFF_SUCCESS, 
            payload: {
                staff: staffData,
                total,
                page: currentPage,
                limit: currentLimit
            } 
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching staff:', error);
        toast.error('Error fetching staff members');
        dispatch({ type: GET_STAFF_ERROR });
    }
};

// Get staff members for a specific business (customer side)
export const getBusinessStaff = (businessId) => async (dispatch) => {
    dispatch({ type: GET_STAFF_START });
    try {
        const response = await axiosInstance.get(`/business-staff/business/${businessId}`);
        console.log('Business Staff Response:', response.data); // Debug log
        
        // Handle different response formats
        let staffData = [];
        
        if (response.data.data) {
            // Handle paginated array structure: [ { data: [], total, page, limit } ]
            if (Array.isArray(response.data.data) && response.data.data[0] && typeof response.data.data[0] === 'object' && 'data' in response.data.data[0]) {
                const paginatedObj = response.data.data[0];
                staffData = paginatedObj.data || [];
            } else if (Array.isArray(response.data.data) && Array.isArray(response.data.data[0])) {
                staffData = response.data.data[0];
            } else {
                staffData = response.data.data;
            }
        } else {
            staffData = response.data || [];
        }
        
        console.log('Processed Business Staff Data:', staffData); // Debug log
        dispatch({ 
            type: GET_STAFF_SUCCESS, 
            payload: {
                staff: staffData,
                total: staffData.length,
                page: 1,
                limit: staffData.length
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching business staff:', error);
        dispatch({ type: GET_STAFF_ERROR });
    }
};

// Add new staff member
export const addStaff = (formData, onSuccess = () => {}) => async (dispatch) => {
    dispatch({ type: ADD_STAFF_START });
    try {
        const response = await axiosInstance.post('/business-staff/add', formData);
        dispatch({ type: ADD_STAFF_SUCCESS });
        toast.success('Staff member added successfully');
        dispatch(getStaff());
        onSuccess();
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Error adding staff member');
        dispatch({ type: ADD_STAFF_ERROR });
    }
};

// Update staff member
export const updateStaff = (id, formData, onSuccess = () => {}) => async (dispatch) => {
    dispatch({ type: UPDATE_STAFF_START });
    try {
        const response = await axiosInstance.put(`/business-staff/update/${id}`, formData);
        dispatch({ type: UPDATE_STAFF_SUCCESS });
        toast.success('Staff member updated successfully');
        dispatch(getStaff());
        onSuccess();
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Error updating staff member');
        dispatch({ type: UPDATE_STAFF_ERROR });
    }
};

// Delete staff member
export const deleteStaff = (id, onSuccess = () => {}) => async (dispatch) => {
    dispatch({ type: DELETE_STAFF_START });
    try {
        await axiosInstance.delete(`/business-staff/${id}`);
        dispatch({ type: DELETE_STAFF_SUCCESS });
        toast.success('Staff member deleted successfully');
        dispatch(getStaff());
        onSuccess();
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Error deleting staff member');
        dispatch({ type: DELETE_STAFF_ERROR });
    }
};
